import { ProductEditor } from './ProductEditor.js';
import { ComponentType, InteriorInteraction } from './InteriorInteraction.js';
import { MultiStepProductEditor } from './MultiStepProductEditor.js';

export class InteriorEditor extends ProductEditor {
  constructor(config, designerService, productService) {
    super(config, designerService, productService);
    this.componentType = ComponentType;
  }

  assignEditFieldElements(elementIds) {
    super.assignEditFieldElements(elementIds);
    this.elements.finish = document.getElementById(elementIds.finish);
  }

  /**
   * Factory method used by the owner ProductPageViewModel.
   */
  createPopupEditor(editDrawing) {
    return new MultiStepProductEditor(editDrawing, this.config.UI.popupEditor,
      ComponentType.mainFinish, InteriorInteraction, 'InteriorPopupEditorVM');
  }

  /** Adds button html elements to the buttons array parameter. */
  registerPopupEditorButtons(buttons) {
    super.registerPopupEditorButtons(buttons);
    buttons.push(this.elements.finish);
  }

  ///**
  // * Assigns BootStrap a modal popup "show" event handler which rebuilds the popup editor based
  // * on the currently edited component type (based on which button was clicked). Note, the method
  // * first calls the super method to add additional popup event handlers .
  // */
  //addPopupEditorHandlers() {
  //  super.addPopupEditorHandlers();
  //  const popup = jQuery(this.popupEditorConfig.elements.modalPopup);
  //  popup.on('show.bs.modal', async (event) => {
  //    if (this.popupEditorDisplayed) {
  //      const typeId = popup.data('compType');
  //      this.editedComponentType = ComponentType[typeId];
  //      this.rebuildPopupEditor(this.editedComponentType);
  //    }
  //  });
  //}

  rebuildValidValuesMaps(validators) {
    super.rebuildValidValuesMaps(validators);
    this.validValuesMap.mainFinish = validators.finish.values;
  }

  createSortedGalleryItems(componentType) {
    const validValues = this.validValuesMap[componentType.id];
    const allValuesMap = this.allFinishesMap;
    return this.createSortedValues(validValues, allValuesMap);
  }

  doDisplayProduct(product, validators, changedElement, changeLog) {
    super.doDisplayProduct(product, validators, changedElement, changeLog);
    this.assignValidValue(this.elements.finish, this.allFinishesMap, product.f, changeLog, 'Finish', changedElement);
  }
}

export class SideWallEditor extends InteriorEditor {
  constructor(config, designerService, productService) {
    super(config, designerService, productService);
    const byId = id => document.getElementById(id);
    const elementIds = config.UI.El;

    if (this.isFieldVisible(this.fieldsCfg.thickness)) {
      this.elements.thickness = byId(elementIds.thickness);
      this.addNumberRadioListEventHandlers(this.elements.thickness, (changedElement, changedValue) => {
        this.propertyChanged('inputT', changedValue, changedElement);
      });
    }

    if (this.isFieldVisible(this.fieldsCfg.width)) {
      this.elements.width = byId(elementIds.width);
      this.addNumberRadioListEventHandlers(this.elements.width, (changedElement, changedValue) => {
        this.propertyChanged('w', changedValue, changedElement);
      });
    }

    if (this.isFieldVisible(this.fieldsCfg.height)) {
      this.elements.height = byId(elementIds.height);
      this.addNumberInputEventHandlers(this.elements.height, (changedElement, changedValue) => {
        this.propertyChanged('h', changedValue, changedElement);
      });
    }
  }

  doDisplayProduct(product, validators, changedElement, changeLog) {
    super.doDisplayProduct(product, validators, changedElement, changeLog);

    if (this.isFieldVisible(this.fieldsCfg.thickness)) {
      const validator = validators ? validators.inputThickness : null;
      this.displayRadioListInput(this.elements.thickness, product.inputT, validator,
        this.fieldsCfg.thickness, changeLog, 'Thickness', changedElement);
    }

    if (this.isFieldVisible(this.fieldsCfg.height)) {
      const validator = validators ? validators.height : null;
      this.displayNumberInput(this.elements.height, product.h, validator,
        this.fieldsCfg.height, changeLog, 'Height', changedElement);
    }

    if (this.isFieldVisible(this.fieldsCfg.width)) {
      const validator = validators ? validators.width : null;
      this.displayRadioListInput(this.elements.width, product.w, validator,
        this.fieldsCfg.width, changeLog, 'Width', changedElement);
    }
  }
}

export class FlexiSideEditor extends InteriorEditor {
  constructor(config, designerService, productService) {
    super(config, designerService, productService);
    const byId = id => document.getElementById(id);
    const elementIds = config.UI.El;

    if (this.isFieldVisible(this.fieldsCfg.width)) {
      this.elements.width = byId(elementIds.width);
      this.addNumberRadioListEventHandlers(this.elements.width, (changedElement, changedValue) => {
        this.propertyChanged('w', changedValue, changedElement);
      });
    }

    if (this.isFieldVisible(this.fieldsCfg.height)) {
      this.elements.height = byId(elementIds.height);
      this.addNumberInputEventHandlers(this.elements.height, (changedElement, changedValue) => {
        this.propertyChanged('h', changedValue, changedElement);
      });
    }
  }

  doDisplayProduct(product, validators, changedElement, changeLog) {
    super.doDisplayProduct(product, validators, changedElement, changeLog);

    if (this.isFieldVisible(this.fieldsCfg.width)) {
      const validator = validators ? validators.width : null;
      this.displayRadioListInput(this.elements.width, product.w, validator,
        this.fieldsCfg.width, changeLog, 'Width', changedElement);
    }

    if (this.isFieldVisible(this.fieldsCfg.height)) {
      const validator = validators ? validators.height : null;
      this.displayNumberInput(this.elements.height, product.h, validator,
        this.fieldsCfg.height, changeLog, 'Height', changedElement);
    }
  }
}

export class FlexiShelfEditor extends InteriorEditor {
  constructor(config, designerService, productService) {
    super(config, designerService, productService);
    const byId = id => document.getElementById(id);
    const elementIds = config.UI.El;

    if (this.isFieldVisible(this.fieldsCfg.width)) {
      this.elements.width = byId(elementIds.width);
      this.addNumberRadioListEventHandlers(this.elements.width, (changedElement, changedValue) => {
        this.propertyChanged('w', changedValue, changedElement);
      });
    }

    if (this.isFieldVisible(this.fieldsCfg.depth)) {
      this.elements.depth = byId(elementIds.depth);
      this.addNumberRadioListEventHandlers(this.elements.depth, (changedElement, changedValue) => {
        this.propertyChanged('d', changedValue, changedElement);
      });
    }
  }

  doDisplayProduct(product, validators, changedElement, changeLog) {
    super.doDisplayProduct(product, validators, changedElement, changeLog);

    if (this.isFieldVisible(this.fieldsCfg.width)) {
      const validator = validators ? validators.width : null;
      this.displayRadioListInput(this.elements.width, product.w, validator,
        this.fieldsCfg.width, changeLog, 'Width', changedElement);
    }

    if (this.isFieldVisible(this.fieldsCfg.depth)) {
      const validator = validators ? validators.depth : null;
      this.displayRadioListInput(this.elements.depth, product.d, validator,
        this.fieldsCfg.depth, changeLog, 'Depth', changedElement);
    }
  }
}

export class FlexiBasketAndTracksEditor extends InteriorEditor {
  constructor(config, designerService, productService) {
    super(config, designerService, productService);
    const byId = id => document.getElementById(id);
    const elementIds = config.UI.El;

    if (this.isFieldVisible(this.fieldsCfg.width)) {
      this.elements.width = byId(elementIds.width);
      this.addNumberRadioListEventHandlers(this.elements.width, (changedElement, changedValue) => {
        this.propertyChanged('w', changedValue, changedElement);
      });
    }

    if (this.isFieldVisible(this.fieldsCfg.height)) {
      this.elements.height = byId(elementIds.height);
      this.addNumberRadioListEventHandlers(this.elements.height, (changedElement, changedValue) => {
        this.propertyChanged('h', changedValue, changedElement);
      });
    }

    if (this.isFieldVisible(this.fieldsCfg.depth)) {
      this.elements.depth = byId(elementIds.depth);
      this.addNumberRadioListEventHandlers(this.elements.depth, (changedElement, changedValue) => {
        this.propertyChanged('d', changedValue, changedElement);
      });
    }
  }

  doDisplayProduct(product, validators, changedElement, changeLog) {
    super.doDisplayProduct(product, validators, changedElement, changeLog);

    if (this.isFieldVisible(this.fieldsCfg.width)) {
      const validator = validators ? validators.width : null;
      this.displayRadioListInput(this.elements.width, product.w, validator,
        this.fieldsCfg.width, changeLog, 'Width', changedElement);
    }

    if (this.isFieldVisible(this.fieldsCfg.height)) {
      const validator = validators ? validators.height : null;
      this.displayRadioListInput(this.elements.height, product.h, validator,
        this.fieldsCfg.height, changeLog, 'Height', changedElement);
    }

    if (this.isFieldVisible(this.fieldsCfg.depth)) {
      const validator = validators ? validators.depth : null;
      this.displayRadioListInput(this.elements.depth, product.d, validator,
        this.fieldsCfg.depth, changeLog, 'Depth', changedElement);
    }
  }
}

export class MeshBasketAndTracksEditor extends InteriorEditor {
  constructor(config, designerService, productService) {
    super(config, designerService, productService);
    const byId = id => document.getElementById(id);
    const elementIds = config.UI.El;

    if (this.isFieldVisible(this.fieldsCfg.width)) {
      this.elements.width = byId(elementIds.width);
      this.addNumberRadioListEventHandlers(this.elements.width, (changedElement, changedValue) => {
        this.propertyChanged('w', changedValue, changedElement);
      });
    }

    if (this.isFieldVisible(this.fieldsCfg.height)) {
      this.elements.height = byId(elementIds.height);
      this.addNumberRadioListEventHandlers(this.elements.height, (changedElement, changedValue) => {
        this.propertyChanged('h', changedValue, changedElement);
      });
    }

    if (this.isFieldVisible(this.fieldsCfg.depth)) {
      this.elements.depth = byId(elementIds.depth);
      this.addNumberRadioListEventHandlers(this.elements.depth, (changedElement, changedValue) => {
        this.propertyChanged('d', changedValue, changedElement);
      });
    }
  }

  doDisplayProduct(product, validators, changedElement, changeLog) {
    super.doDisplayProduct(product, validators, changedElement, changeLog);

    if (this.isFieldVisible(this.fieldsCfg.width)) {
      const validator = validators ? validators.width : null;
      this.displayRadioListInput(this.elements.width, product.w, validator,
        this.fieldsCfg.width, changeLog, 'Width', changedElement);
    }

    if (this.isFieldVisible(this.fieldsCfg.height)) {
      const validator = validators ? validators.height : null;
      this.displayRadioListInput(this.elements.height, product.h, validator,
        this.fieldsCfg.height, changeLog, 'Height', changedElement);
    }

    if (this.isFieldVisible(this.fieldsCfg.depth)) {
      const validator = validators ? validators.depth : null;
      this.displayRadioListInput(this.elements.depth, product.d, validator,
        this.fieldsCfg.depth, changeLog, 'Depth', changedElement);
    }
  }
}

class FloorModuleEditor extends InteriorEditor {
  constructor(config, designerService, productService) {
    super(config, designerService, productService);
    const byId = id => document.getElementById(id);
    const elementIds = config.UI.El;

    if (this.isFieldVisible(this.fieldsCfg.heightType)) {
      this.elements.heightType = byId(elementIds.heightType);
      this.elements.heightType.dataset.suppressChgMsg = true;
      this.addStringRadioListEventHandlers(this.elements.heightType, (changedElement, changedValue) => {
        this.propertyChanged('heightType', changedValue, changedElement);
      });
    }

    if (this.isFieldVisible(this.fieldsCfg.height)) {
      this.elements.height = byId(elementIds.height);
      this.addNumberInputEventHandlers(this.elements.height, (changedElement, changedValue) => {
        this.propertyChanged('h', changedValue, changedElement);
      });
    }

    if (this.isFieldVisible(this.fieldsCfg.depth)) {
      this.elements.depth = byId(elementIds.depth);
      this.addNumberRadioListEventHandlers(this.elements.depth, (changedElement, changedValue) => {
        this.propertyChanged('d', changedValue, changedElement);
      });
    }
  }

  assignEditFieldElements(elementIds) {
    super.assignEditFieldElements(elementIds);
    this.elements.metalFinish = document.getElementById(elementIds.metalFinish);
  }

  /** Adds button html elements to the buttons array parameter. */
  registerPopupEditorButtons(buttons) {
    super.registerPopupEditorButtons(buttons);
    buttons.push(this.elements.metalFinish);
  }

  displayWidthInput(validators, product, changeLog, changedElement) {
    if (this.isFieldVisible(this.fieldsCfg.width)) {
      const validator = validators ? validators.width : null;
      this.displayNumberInput(this.elements.width, product.w, validator,
        this.fieldsCfg.width, changeLog, 'Width', changedElement);
    }
  }

  displayHeightTypeInput(validators, product, changeLog, changedElement) {
    if (this.isFieldVisible(this.fieldsCfg.heightType)) {
      const validator = validators ? validators.heightType : null;
      this.displayRadioListInput(this.elements.heightType, product.heightType, validator,
        this.fieldsCfg.heightType, changeLog, 'Height Type', changedElement,
        this.config.heightTypeDValues);
    }
  }

  displayHeightInput(validators, product, changeLog, changedElement) {
    if (this.isFieldVisible(this.fieldsCfg.height)) {
      const validator = validators ? validators.height : null;
      const readOnly = product.heightType !== 'Custom';
      this.displayNumberInput(this.elements.height, product.h, validator,
        this.fieldsCfg.height, changeLog, 'Height', changedElement, readOnly);
    }
  }

  displayDepthInput(validators, product, changeLog, changedElement) {
    if (this.isFieldVisible(this.fieldsCfg.depth)) {
      const validator = validators ? validators.depth : null;
      this.displayRadioListInput(this.elements.depth, product.d, validator,
        this.fieldsCfg.depth, changeLog, 'Depth', changedElement);
    }
  }

  doOnPopupEditorDisplayed(event) {
    super.doOnPopupEditorDisplayed(event);
    /* Let the base class editor know that we only need to send the changed finish on the root object
     * (e.g. the flexi-section) to the server. There's no need to send every changed finish on components. */
    if (this.editedComponentType.id === 'mainFinish') {
      this.popupEditorChangeType.isAtomic = true;
      this.popupEditorChangeType.propertyName = 'f';
    } else if (this.editedComponentType.id === 'metalFinish') {
      this.popupEditorChangeType.isAtomic = true;
      this.popupEditorChangeType.propertyName = 'metalF';
    }
  }

  rebuildValidValuesMaps(validators) {
    super.rebuildValidValuesMaps(validators);
    this.validValuesMap.metalFinish = validators.metalFinish.values;
  }

  doDisplayProduct(product, validators, changedElement, changeLog) {
    super.doDisplayProduct(product, validators, changedElement, changeLog);
    this.assignValidValue(this.elements.metalFinish, this.allFinishesMap, product.metalF, changeLog, 'Metal Finish', changedElement);
  }
}

export class FlexiSectionEditor extends FloorModuleEditor {
  constructor(config, designerService, productService) {
    super(config, designerService, productService);

    if (this.isFieldVisible(this.fieldsCfg.width)) {
      this.elements.innerWidth = document.getElementById(config.UI.El.innerWidth);

      this.addNumberRadioListEventHandlers(this.elements.innerWidth, (changedElement, changedValue) => {
        this.propertyChanged('innerW', changedValue, changedElement);
      });
    }
  }

  doDisplayProduct(product, validators, changedElement, changeLog) {
    super.doDisplayProduct(product, validators, changedElement, changeLog);
    this.displayInnerWidthInput(validators, product, changeLog, changedElement);
    this.displayHeightTypeInput(validators, product, changeLog, changedElement);
    this.displayHeightInput(validators, product, changeLog, changedElement);
    this.displayDepthInput(validators, product, changeLog, changedElement);
  }

  displayInnerWidthInput(validators, product, changeLog, changedElement) {
    if (this.isFieldVisible(this.fieldsCfg.width)) {
      let validator = validators ? validators.innerWidth : null;
      this.displayRadioListInput(this.elements.innerWidth, product.innerW, validator,
        this.fieldsCfg.width, changeLog, 'Width, inner', changedElement);
      return validator;
    }
  }
}

class StandardModuleEditor extends FloorModuleEditor {
  constructor(config, designerService, productService) {
    super(config, designerService, productService);
    if (this.isFieldVisible(this.fieldsCfg.width)) {
      this.elements.width = document.getElementById(config.UI.El.width);
      this.addNumberInputEventHandlers(this.elements.width, (changedElement, changedValue) => {
        this.propertyChanged('w', changedValue, changedElement);
      });
    }
  }

  doDisplayProduct(product, validators, changedElement, changeLog) {
    super.doDisplayProduct(product, validators, changedElement, changeLog);
    this.displayWidthInput(validators, product, changeLog, changedElement);
    this.displayHeightTypeInput(validators, product, changeLog, changedElement);
    this.displayHeightInput(validators, product, changeLog, changedElement);
    this.displayDepthInput(validators, product, changeLog, changedElement);
  }
}

export class ClosetOrganizerEditor extends StandardModuleEditor {
}
